import React, { useEffect, useState } from "react";
import axios from "axios";
import "./VinosList.css";

const VinosList = () => {
  const [vinos, setVinos] = useState([]);
  const [filteredVinos, setFilteredVinos] = useState([]);
  const [editingVino, setEditingVino] = useState(null);
  const [filter, setFilter] = useState("");
  const [error, setError] = useState(null);

  // Obtener lista de vinos
  const fetchVinos = async () => {
    try {
      const response = await axios.get("http://127.0.0.1:5000/vinos");
      setVinos(response.data);
      setFilteredVinos(response.data);
    } catch (err) {
      setError("Error al cargar los vinos.");
    }
  };

  useEffect(() => {
    fetchVinos();
  }, []);

  const handleInputChange = (field, value) => {
    if (editingVino) {
      setEditingVino((prev) => ({
        ...prev,
        [field]: field === "precio" ? parseFloat(value) || 0 : value,
      }));
    }
  };

  const handleEdit = (vino) => {
    setEditingVino({ ...vino });
  };

  const handleSave = async (id) => {
    if (!editingVino.nombre || !editingVino.precio) {
      alert("Por favor, completa todos los campos obligatorios.");
      return;
    }
  
    const vinoActualizado = {
      nombre: editingVino.nombre || "",
      variedad_uva: editingVino.variedad_uva || "",
      region: editingVino.region || "",
      tipo: editingVino.tipo || "",
      descripcion: editingVino.descripcion || "",
      etiqueta_url: editingVino.etiqueta_url || "",
      precio: editingVino.precio || 0,
      disponible: editingVino.disponible ? 1 : 0, // Convierte booleanos a enteros si es necesario
    };
  
    console.log("Datos preparados para guardar:", vinoActualizado);
  
    try {
      const response = await axios.put(
        `http://127.0.0.1:5000/vinos/${id}`,
        vinoActualizado,
        { headers: { "Content-Type": "application/json" } }
      );
      console.log(response.data.mensaje);
  
      setVinos((prev) =>
        prev.map((v) => (v.id === id ? { ...v, ...vinoActualizado } : v))
      );
      setFilteredVinos((prev) =>
        prev.map((v) => (v.id === id ? { ...v, ...vinoActualizado } : v))
      );
      setEditingVino(null);
    } catch (error) {
      console.error("Error al guardar el vino:", error);
      setError("Hubo un error al guardar los cambios.");
    }
  };
  

  const handleDelete = async (id) => {
    try {
      await axios.delete(`http://127.0.0.1:5000/vinos/${id}`);
      setVinos((prev) => prev.filter((vino) => vino.id !== id));
      setFilteredVinos((prev) =>
        prev.filter((vino) => vino.id !== id)
      );
    } catch (err) {
      setError("Hubo un error al eliminar el vino.");
    }
  };

  const handleToggleDisponibilidad = async (id, disponible) => {
    try {
      await axios.put(`http://127.0.0.1:5000/vinos/${id}`, {
        disponible: !disponible,
      });
      setVinos((prevVinos) =>
        prevVinos.map((vino) =>
          vino.id === id ? { ...vino, disponible: !disponible } : vino
        )
      );
      setFilteredVinos((prevFiltered) =>
        prevFiltered.map((vino) =>
          vino.id === id ? { ...vino, disponible: !disponible } : vino
        )
      );
    } catch (err) {
      setError("No se pudo actualizar la disponibilidad.");
    }
  };

  const handleFilterChange = (e) => {
    const value = e.target.value.toLowerCase();
    setFilter(value);
    setFilteredVinos(
      vinos.filter(
        (vino) =>
          vino.nombre.toLowerCase().includes(value) ||
          vino.region.toLowerCase().includes(value)
      )
    );
  };

  const handleImageChange = (id, file) => {
    const formData = new FormData();
    formData.append("imagen", file);
  
    axios
      .post(`http://127.0.0.1:5000/vinos/${id}/imagen`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log("Imagen actualizada:", response.data.imagen_url);
  
        setVinos((prevVinos) =>
          prevVinos.map((vino) =>
            vino.id === id
              ? { ...vino, etiqueta_url: response.data.imagen_url }
              : vino
          )
        );
        setFilteredVinos((prevFiltered) =>
          prevFiltered.map((vino) =>
            vino.id === id
              ? { ...vino, etiqueta_url: response.data.imagen_url }
              : vino
          )
        );
      })
      .catch((error) => {
        console.error("Error al actualizar la imagen:", error);
        setError("No se pudo actualizar la imagen.");
      });
  };
  

  return (
    <div className="vinos-list">
      <h1>Gestión de Vinos</h1>
      {error && <p className="error">{error}</p>}

      {/* Filtro */}
      <div className="filtro">
        <input
          type="text"
          placeholder="Buscar por nombre o región..."
          value={filter}
          onChange={handleFilterChange}
        />
      </div>

      <div className="vinos-container">
        {filteredVinos.map((vino) => (
          <div key={vino.id} className="vino-card">
            {editingVino && editingVino.id === vino.id ? (
              <>
                <input
                  type="text"
                  value={editingVino.nombre}
                  onChange={(e) => handleInputChange("nombre", e.target.value)}
                />
                <input
                  type="text"
                  value={editingVino.region}
                  onChange={(e) => handleInputChange("region", e.target.value)}
                />
                <input
                  type="text"
                  value={editingVino.variedad_uva}
                  onChange={(e) =>
                    handleInputChange("variedad_uva", e.target.value)
                  }
                />
                <input
                  type="number"
                  value={editingVino.precio}
                  onChange={(e) =>
                    handleInputChange("precio", parseFloat(e.target.value))
                  }
                />
                <textarea
                  value={editingVino.descripcion}
                  onChange={(e) =>
                    handleInputChange("descripcion", e.target.value)
                  }
                />
                <button onClick={() => handleSave(vino.id)}>Guardar</button>
                <button onClick={() => setEditingVino(null)}>Cancelar</button>
              </>
            ) : (
              <>
                <img
                  src={vino.etiqueta_url || "https://via.placeholder.com/300"}
                  alt={vino.nombre}
                  className="vino-imagen"
                />
                <h3>{vino.nombre}</h3>
                <p>Región: {vino.region}</p>
                <p>Uva: {vino.variedad_uva}</p>
                <p>Precio: ${vino.precio.toFixed(2)}</p>
                <p>Descripción: {vino.descripcion}</p>
                <button
                  onClick={() =>
                    handleToggleDisponibilidad(vino.id, vino.disponible)
                  }
                >
                  {vino.disponible ? "Ocultar" : "Mostrar"}
                </button>
                <div className="image-editor">
                  <label>Actualizar Imagen:</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      handleImageChange(vino.id, e.target.files[0])
                    }
                  />
                </div>
                <button onClick={() => handleEdit(vino)}>Editar</button>
                <button onClick={() => handleDelete(vino.id)}>Eliminar</button>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default VinosList;
